import { immerable } from 'immer';
import { Set } from 'immutable';

import { DcCoreElementType } from '../dc-core-types';
import { ElementPermission } from './permission-types';

interface IPermissionListEntity {
	list: Set<string>;
}
const entityDefaults: IPermissionListEntity = {
	list: Set(),
};

export class PermissionList implements IPermissionListEntity {
	private [immerable] = true;
	public list = entityDefaults.list;

	public static build(
		params: Partial<IPermissionListEntity> = {}
	): PermissionList {
		const instance = new PermissionList();
		instance.list = params.list ?? entityDefaults.list;
		return instance;
	}

	public hasCreatePermission(el: DcCoreElementType): boolean {
		return this.list.has(`${el.toLowerCase()}-${ElementPermission.Create}`);
	}

	public hasListPermission(el: DcCoreElementType): boolean {
		return this.list.has(`${el.toLowerCase()}`);
	}

	public hasElementPermission(
		el: DcCoreElementType,
		elementId: number,
		permission: ElementPermission
	): boolean {
		return this.list.has(`${el.toLowerCase()}-${elementId}-${permission}`);
	}

	public getElementPermissions(
		el: DcCoreElementType,
		elementId: number
	): Set<ElementPermission> {
		const prefix = `${el.toLowerCase()}-${elementId}-`;
		return this.list
			.filter((p) => p.startsWith(prefix))
			.map((p) => p.replace(prefix, '') as ElementPermission);
	}
}
